// Domain · BorderTypeChip helpers
//
// Tone + label resolution for the `transactions.border_type` enum.
// Split out of `BorderTypeChip.tsx` so that module exports components only.

import type { PillTone } from "@ds/display/Pill";

export type BorderType = "domestic" | "eu" | "non_eu";

const TONE_MAP: Record<BorderType, PillTone> = {
  domestic: "grey",
  eu:       "blue",
  non_eu:   "amber",
};

const LABEL: Record<BorderType, string> = {
  domestic: "Krajowy",
  eu:       "UE",
  non_eu:   "Poza UE",
};

/** Resolve a border-type value to its canonical `PillTone`. */
export function borderTypeTone(value: BorderType | null | undefined): PillTone {
  return value ? TONE_MAP[value] : "grey";
}

/** Resolve a border-type value to its canonical Polish label. */
export function borderTypeText(value: BorderType | null | undefined): string {
  return value ? LABEL[value] : "—";
}
